import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import LabelAndInputMask from "../common/form/labelAndInputMask";
import Select from "../common/form/select";
import { setModoTela, initForm, setImportacaoValidada, getListaFaturasAdm, importar } from "./faturaAguaActions";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { setError } from "../common/toast/toast";
import { useState } from "react";
import { useEffect } from "react";

function FaturaAguaForm(props) {
    const [state, setState] = useState({ exibirImportadorArquivo: false });

    useEffect(() => {
        return () => props.setModoTela("lista");
    }, []);

    const usuarioFaturaEdicao = props.usuarioLogado && (props.usuarioLogado.acesso_fatura_editar || props.usuarioLogado.acesso_fatura_editar_fechado);
    const readOnly = props.visualizar || props.excluir || props.formularioValues.importacao_validada || !usuarioFaturaEdicao;

    if (!props.formularioValues || !props.usuarioLogado) return null;

    return (
        <div>
            <ContentCard>
                {/*ALERTAS*/}
                {props.formularioValues.erros.map((erro, index) => (
                    <div key={erro.mensagem + "-" + index} className={`alert alert-${props.formularioValues.importacao_validada ? "warning" : "danger"} alert-dismissible`}>
                        <h6>Importação</h6>
                        {erro.mensagem}
                    </div>
                ))}

                {props.formularioValues.id && props.formularioValues.arquivo_pdf ? (
                    <ContentCardHeader>
                        <Row>
                            {/*Validar Importação*/}
                            {!props.formularioValues.importacao_validada ? (
                                <Grid cols="6 6 4 3">
                                    <Button
                                        text="Validar e Fechar"
                                        type={"success"}
                                        icon={"fa fa-check"}
                                        disabled={props.visualizar || !usuarioFaturaEdicao}
                                        event={() => {
                                            props.setImportacaoValidada({
                                                ...props.formularioValues,
                                                importacao_validada: true,
                                            });
                                        }}
                                    />
                                </Grid>
                            ) : props.formularioValues.importacao_validada ? (
                                <Grid cols="6 6 4 3">
                                    <Button
                                        text="Reabrir"
                                        type={"danger"}
                                        icon={"fa fa-unlock"}
                                        //só editar fechado pode reabrir
                                        disabled={props.visualizar || !props.usuarioLogado.acesso_fatura_editar_fechado}
                                        event={() => {
                                            props.setImportacaoValidada({
                                                ...props.formularioValues,
                                                importacao_validada: false,
                                            });
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Row>
                    </ContentCardHeader>
                ) : null}
                <Form event={props.handleSubmit}>
                    <ContentCardBody>
                        <Grid cols="12 12 12 12">
                            <Row>
                                <Select
                                    name="id_cliente"
                                    options={props.listaCliente}
                                    label="Cliente"
                                    cols="12 12 12 12"
                                    placeholder="Selecione o cliente"
                                    value={props.formularioValues.id_cliente}
                                    readOnly={readOnly}
                                    onChange={(data) => {
                                        props.initForm({
                                            ...props.formularioValues,
                                            id_cliente: data,
                                            id_unidade_consumidora: null,
                                            id_unidade_consumidora_agua: null,
                                        });
                                    }}
                                />
                            </Row>
                            <Row>
                                <Select
                                    name="id_unidade_consumidora_agua"
                                    options={props.listaUnidadeConsumidora.filter((item) => item.id_cliente == props.formularioValues.id_cliente)}
                                    label="Unidade Consumidora"
                                    cols="12 12 12 12"
                                    placeholder="Selecione a unidade consumidora"
                                    value={props.formularioValues.id_unidade_consumidora_agua}
                                    readOnly={readOnly}
                                    onChange={(data) => {
                                        const ucAgua = props.listaUnidadeConsumidora.find((uc) => uc.id == data);
                                        props.initForm({
                                            ...props.formularioValues,
                                            id_unidade_consumidora_agua: data,
                                            id_unidade_consumidora: ucAgua ? ucAgua.id_unidade_consumidora : null,
                                        });
                                    }}
                                />
                            </Row>
                            <Row>
                                <Field
                                    name="competencia"
                                    component={LabelAndInputMask}
                                    label="Competência"
                                    placeholder="Informe a competência"
                                    cols="12 12 12 12"
                                    mask="99/9999"
                                    readOnly={readOnly}
                                />
                            </Row>
                            <Row>
                                <Field
                                    name="observacao"
                                    component={LabelAndInput}
                                    label="Observação da análise de importação"
                                    placeholder="Informe a observação da análise de importação"
                                    cols="12 12 12 12"
                                    readOnly={readOnly}
                                />
                            </Row>
                            <Row>
                                <LabelAndInputNumber
                                    name="valor_fatura"
                                    label="Valor Importado da Fatura (R$)"
                                    placeholder="0,00"
                                    cols="12 12 12 12"
                                    casas={2}
                                    readOnly={!props.formularioValues.id || readOnly}
                                    value={props.formularioValues.valor_fatura}
                                    onChange={(data) => {
                                        props.initForm({
                                            ...props.formularioValues,
                                            valor_fatura: data.target.value,
                                        });
                                    }}
                                />
                            </Row>
                            <Row>
                                <LabelAndInputNumber
                                    name="quantidade_agua_consumida"
                                    label="Água Consumida (m³)"
                                    placeholder="0,00"
                                    cols="12 12 12 12"
                                    casas={2}
                                    readOnly={!props.formularioValues.id || readOnly}
                                    value={props.formularioValues.quantidade_agua_consumida}
                                    onChange={(data) => {
                                        props.initForm({
                                            ...props.formularioValues,
                                            quantidade_agua_consumida: data.target.value,
                                        });
                                    }}
                                />
                            </Row>
                            {!props.formularioValues.id && !props.formularioValues.arquivo_pdf ? (
                                <span style={{ color: "red", padding: 7, marginBottom: 10 }}>Clique em salvar para desbloquear o botão de importar arquivo</span>
                            ) : null}
                            {!state.exibirImportadorArquivo ? (
                                <Row>
                                    <Grid cols="12 12 4 3">
                                        <Button
                                            text={props.formularioValues.arquivo_pdf ? "Substituir PDF" : "Importar PDF"}
                                            type={"primary"}
                                            disabled={!props.formularioValues.id || props.formularioValues.importacao_validada || !usuarioFaturaEdicao}
                                            icon={"fa fa-file-import"}
                                            event={() => {
                                                setState({ ...state, exibirImportadorArquivo: true });
                                            }}
                                        />
                                    </Grid>
                                </Row>
                            ) : (
                                <Row>
                                    <Grid cols="12 12 9 9">
                                        <div className="form-group">
                                            <div className="custom-file">
                                                <input
                                                    className="custom-file-input"
                                                    type="file"
                                                    id="customFile"
                                                    accept="application/pdf"
                                                    onChange={(event) => {
                                                        event.preventDefault();
                                                        let reader = new FileReader();
                                                        let file = event.target.files[0];

                                                        if (!file.type.includes("application/pdf")) {
                                                            setError("Erro", "Selecione apenas PDF.");
                                                            return;
                                                        }

                                                        reader.onloadend = () => {
                                                            props.importar(props.formularioValues.id, reader.result, () => setState({ ...state, exibirImportadorArquivo: false }));
                                                        };

                                                        reader.readAsDataURL(file);
                                                    }}
                                                />
                                                <label className="custom-file-label" for="customFile">
                                                    Selecione
                                                </label>
                                            </div>
                                        </div>
                                    </Grid>

                                    <Grid cols="12 12 3 3">
                                        <Button text="Cancelar" type={"danger"} icon={"fa fa-times"} event={() => setState({ ...state, exibirImportadorArquivo: false })} />
                                    </Grid>
                                </Row>
                            )}
                        </Grid>
                    </ContentCardBody>
                    <ContentCardFooter style={{ backgroundColor: "#FFFFFF" }}>
                        <Row alignCenter>
                            {props.excluir ? (
                                <Grid cols="6 6 4 3">
                                    <Button
                                        text="Excluir"
                                        submit
                                        type={"danger"}
                                        disabled={props.formularioValues.importacao_validada || !usuarioFaturaEdicao}
                                        icon={"fa fa-trash"}
                                    />
                                </Grid>
                            ) : (
                                <Grid cols="6 6 4 3">
                                    <Button
                                        text="Salvar"
                                        submit
                                        disabled={props.visualizar || props.formularioValues.importacao_validada || !usuarioFaturaEdicao}
                                        type={"success"}
                                        icon={"fa fa-check"}
                                    />
                                </Grid>
                            )}

                            <Grid cols="6 6 4 3">
                                <Button
                                    text="Voltar"
                                    type={"warning"}
                                    icon={"fa fa-chevron-left"}
                                    event={() => {
                                        props.setModoTela("lista");
                                        props.getListaFaturasAdm();
                                    }}
                                />
                            </Grid>
                        </Row>
                    </ContentCardFooter>
                </Form>
            </ContentCard>
        </div>
    );
}

const FaturaAguaFormRedux = reduxForm({ form: "faturaForm", destroyOnUnmount: false })(FaturaAguaForm);
const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("faturaForm")(state),
    listaCliente: state.fatura.listaCliente,
    listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidoraAgua,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            getListaFaturasAdm,
            setImportacaoValidada,
            setArquivoPDF,
            importar,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(FaturaAguaFormRedux);
